export class TransferResolver {
    constructor(providers) {
        this.providers = providers || [];
    }
    async executeTransfer(params, wallet, onProgress) {
        const provider = this.providers.find(p => p.supportsNetwork(params.network));
        if (!provider) {
            const error = `No transfer provider found for network: ${params.network.name}`;
            console.warn(error);
            throw error;
        }
        return provider.executeTransfer(params, wallet, onProgress);
    }
}
